import React, { Component } from 'react'
import VehicleDetails from '.';

import './VehicleDetails.scss';

class VehicleDetailsPrincipalInformation extends Component {
	
	render() {
		return (
			<VehicleDetails className={this.props.className ? this.props.className : ''} id={this.props.id ? this.props.id : ''} title={this.props.title ? this.props.title : ''}>
				{this.renderPrincipalInformation()}
			</VehicleDetails>
		)
	}
}
export default VehicleDetailsPrincipalInformation